import type { ConfigOf } from "../../../install/types.ts";
import {
  Element,
  InstallSpec,
  ItemComponent,
  Option,
} from "../../../install/types.ts";

const iamLoginOption = Option({
  label: "As Oracle IAM users",
  schema: {
    identity: Element({
      label: "How are users identified?",
      type: "select",
      default: "email",
      options: {
        email: Option({
          label: "User name is user email",
          schema: {},
        }),
      },
    }),
  },
});

export const loginOptions = {
  iam: iamLoginOption,
};

export const OracleComponents = InstallSpec({
  "iam-write": ItemComponent({
    label: "IAM management",
    description:
      "Allows P0 to grant and revoke Oracle Cloud Infrastructure access for your users. Required for just-in-time access.",
    type: "string",
    maturity: "preview",
    schema: {
      /**
       * OCI only supports managing users who are already present in OCI IAM.
       *
       * TODO: Support federated users via OCI Identity Federation (e.g. via OCI Identity Providers and
       * SAML2 connections).
       */
      login: Element({
        label: "How are users provisioned?",
        type: "select" as const,
        default: "iam",
        options: loginOptions,
      }),
      /**
       * Current OCI installation requires an API key for a super-user with admin privileges
       * to manage IAM resources like users and groups.
       *
       * TODO: move to workload identity federation to avoid managing API keys directly.
       */
      tenancyId: Element({
        type: "hidden",
        label: "Tenancy OCID",
      }),
      userId: Element({
        type: "hidden",
        label: "P0 service user OCID",
      }),
      fingerprint: Element({
        type: "hidden",
        label: "API key fingerprint",
      }),
      privateKey: Element({
        type: "hidden",
        label: "API private key",
      }),
      region: Element({
        type: "hidden",
        label: "OCI region",
      }),
    },
    validator: async () => undefined,
  }),
});

export type OracleUse = keyof typeof OracleComponents;
export type OracleIntegration = ConfigOf<typeof OracleComponents>;
export type OracleIntegrationConfig = OracleIntegration["iam-write"]["config"];
